import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, fmtDateTime } from "@/lib/api";

export const NotificationBell = ({ dark = false }) => {
  const [data, setData] = useState({ items: [], unread: 0 });
  const nav = useNavigate();

  const load = useCallback(() => {
    api.get("/notifications").then((r) => setData(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    load();
    const t = setInterval(load, 30000);
    return () => clearInterval(t);
  }, [load]);

  const onOpen = (open) => {
    if (open && data.unread) {
      api.post("/notifications/read-all").then(() => setData((d) => ({ ...d, unread: 0 })));
    }
  };

  return (
    <Popover onOpenChange={onOpen}>
      <PopoverTrigger asChild>
        <button data-testid="notification-bell-button" className={`relative h-10 w-10 grid place-items-center rounded-full transition-colors ${dark ? "hover:bg-slate-800 text-slate-300" : "hover:bg-slate-100 text-slate-600"}`}>
          <Bell className="h-5 w-5" />
          {data.unread > 0 && (
            <span data-testid="notification-unread-count" className="absolute top-1 right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-rose-500 text-white text-[10px] font-bold grid place-items-center">
              {data.unread}
            </span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0 bg-white" data-testid="notification-panel">
        <div className="px-4 py-3 border-b font-heading font-bold text-slate-900">Notifications</div>
        <div className="max-h-80 overflow-y-auto">
          {data.items.length === 0 && <div className="p-6 text-sm text-slate-500 text-center">No notifications yet</div>}
          {data.items.map((n) => (
            <button key={n.id} onClick={() => n.link && nav(n.link)} className="w-full text-left px-4 py-3 border-b last:border-0 hover:bg-slate-50 transition-colors" data-testid={`notification-item-${n.id}`}>
              <div className="text-sm font-semibold text-slate-800">{n.title}</div>
              <div className="text-xs text-slate-600 mt-0.5">{n.body}</div>
              <div className="text-[10px] text-slate-400 mt-1">{fmtDateTime(n.created_at)}</div>
            </button>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
